import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/internal/operators/catchError';
import { CommonService } from 'src/app/shared/services/common-service';
import { environment } from 'src/environments/environment';
import { CampaignDisplayResponse } from '../../responses/user/campaign-display.response';

@Injectable({
    providedIn: 'root'
})
export class CampaignDisplayService extends CommonService {

    constructor(private httpClient: HttpClient) {
        super();
    }

    public getCampaignDisplayPanel(idHealthUnit: number): Observable<CampaignDisplayResponse> {
        let uri = `CampaignDisplay/${idHealthUnit}`;

        return this.httpClient.get<CampaignDisplayResponse>(environment.urlApiUser + uri, this.addHeaderPanelToken())
            .pipe(catchError(this.handleError));
    }
    
    public getCampaignDisplayTotem(idHealthUnit: number): Observable<CampaignDisplayResponse> {
        let uri = `CampaignDisplay/${idHealthUnit}`;

        return this.httpClient.get<CampaignDisplayResponse>(environment.urlApiUser + uri, this.addHeaderHashTotem())
            .pipe(catchError(this.handleError));
    }
}